import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog"; // Importamos el modal
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import LEAsociarPedCtnModal from "./LEAsociarPedCtnModal";
import { MultiStateCheckbox } from "primereact/multistatecheckbox";
import { obtenerTodo } from "../Utils/seleccionproductosxpedidosxcontenedor";
import DashboardContenedor from "../Componentes/DashboardContenedor";
import "../styles/cssAsociarPedCtnModal.css";
import { limpiarSeleccionContenedor } from "../Utils/seleccionproductosxpedidosxcontenedor";
import { limpiarTodo } from "../Utils/seleccionproductosxpedidosxcontenedor";
import AlertasDashboard from "../Componentes/AlertasDashboard";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// convierte "1.234,56" | "1,234.56" | "123,45" | 123.45 a Number
// convierte "1.234,56" | "1,234.56" | "123,45" | 123.45 a Number
const parseDecimalSmart = (val) => {
  if (val == null) return 0;
  if (typeof val === "number") return Number.isFinite(val) ? val : 0;
  let s = String(val).trim().replace(/\s/g, "");
  if (!s) return 0;
  const hasC = s.includes(","),
    hasD = s.includes(".");
  if (hasC && hasD) {
    const lastC = s.lastIndexOf(","),
      lastD = s.lastIndexOf(".");
    s =
      lastC > lastD
        ? s.replace(/\./g, "").replace(",", ".")
        : s.replace(/,/g, "");
  } else if (hasC) s = s.replace(",", ".");
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
};

const AsociarPedContenedorModal = ({
  language,
  isOpen,
  onClose,
  contenedor,
  onUpdateContenedores,
}) => {
  // 🔹 Se agregan props para abrir/cerrar
  //console.log("📦 Contenedor recibido en el modal:", contenedor); // 🔥 Agregar este log

  const [pedidos, setPedidos] = useState([]);
  const [selectedPedidos, setSelectedPedidos] = useState([]);
  //const [cantidadCajas, setCantidadCajas] = useState({});
  //const [pesoCajas, setPesoCajas] = useState({});
  const [modalListasVisible, setModalListasVisible] = useState(false); // ✅ Nuevo modal
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null); // ✅ Pedido actual
  const [estadoCheckPedidos, setEstadoCheckPedidos] = useState({});

  const translations = {
    es: {
      title: "Asociar Pedidos al Contenedor",
      resumen: "Resumen del Contenedor",
      id: "ID",
      estado: "Estado del Contenedor",
      pedidosTitulo: "Listado de Pedidos",
      seleccionar: "Seleccionar",
      cliente: "Cliente",
      estadoPedido: "Estado Pedido",
      cajasPedido: "Cajas Pedido",
      cajasRecibidas: "Cajas Recibidas",
      cajasPendientes: "Cajas Pendientes",
      cantidadAsociar: "Cajas a Asociar",
      pesoAsociar: "Peso Asociado (kg)",
      fechaPedido: "Fecha Pedido",
      botonAsociar: "Asociar Pedidos",
      Marca: "Marca",
    },
  };

  const estadosCheckbox = [
    { value: "checked", icon: "pi pi-check" },
    { value: "unchecked", icon: "" },
    { value: "indeterminate", icon: "pi pi-minus" },
  ];

  const [resumenContenedor, setResumenContenedor] = useState(null);
  const [resumenMostrado, setResumenMostrado] = useState(null);

  const {
    title,
    pedidosTitulo,
    seleccionar,
    cliente,
    estadoPedido,
    botonAsociar,
    Marca,
  } = translations[language] || translations["es"];

  const cargarResumenContenedor = React.useCallback(async () => {
    try {
      if (!contenedor?.IdContenedor) return;
      const res = await fetchWithAuth(
        `${API_URL}/api/getdashboardcontenedor/${contenedor.IdContenedor}`,
      );
      const data = await res.json();
      setResumenContenedor(data);
      setResumenMostrado(data);
    } catch (error) {
      console.error("Error al cargar el resumen del contenedor:", error);
    }
  }, [contenedor?.IdContenedor]);

  useEffect(() => {
    if (isOpen && contenedor) {
      // 🔹 1. Cargar la lista de pedidos
      fetchWithAuth(
        `${API_URL}/api/asociar-lista-pedidos/${contenedor.IdContenedor}`,
      )
        .then((res) => res.json())
        .then((data) => setPedidos(data))
        .catch((err) => console.error("Error al cargar los pedidos:", err));

      // 🔹 2. Cargar cuántos productos tiene cada pedido y su total
      fetchWithAuth(
        `${API_URL}/api/asociar-lista-pedidos/productos-por-pedido/${contenedor.IdContenedor}`,
      )
        .then((res) => res.json())
        .then((data) => {
          const nuevosEstados = {};
          data.forEach((pedido) => {
            const { idpedido, cantidadAsociados, cantidadTotal } = pedido;

            let estado = "unchecked";
            if (cantidadAsociados === 0) {
              estado = "unchecked";
            } else if (cantidadAsociados === cantidadTotal) {
              estado = "checked";
            } else {
              estado = "indeterminate";
            }
            //console.log(`🟢 Pedido ${idpedido}: Estado=${estado}, Asociados=${cantidadAsociados}, Total=${cantidadTotal}`);
            nuevosEstados[idpedido] = { estado };
          });

          setEstadoCheckPedidos((prev) => ({
            ...prev,
            ...nuevosEstados,
          }));
        })
        .catch((err) =>
          console.error("Error al cargar productos por pedido:", err),
        );
      cargarResumenContenedor();
    }
  }, [isOpen, contenedor, cargarResumenContenedor]);

  const handleAbrirListas = (pedido) => {
    const fueSeleccionado = selectedPedidos.some(
      (p) => p.idpedido === pedido.idpedido,
    );
    setPedidoSeleccionado({ ...pedido, seleccionado: fueSeleccionado });
    setModalListasVisible(true);
    //console.log('📦 Abriendo listas de pedido:', pedido.idpedido, '¿Está seleccionado?', fueSeleccionado);
  };

  const actualizarEstadoCheck = (pedidoId, cajasSeleccionadas, totalCajas) => {
    let estado = "unchecked";

    if (cajasSeleccionadas === totalCajas && totalCajas > 0) estado = "checked";
    else if (cajasSeleccionadas > 0) estado = "indeterminate";

    setEstadoCheckPedidos((prev) => ({
      ...prev,
      [pedidoId]: { estado },
    }));

    console.log(`🧩 Pedido ${pedidoId}:`, {
      cajasSeleccionadas,
      totalCajas,
      estado,
    });
  };

  const handleClose = () => {
    limpiarTodo(); // limpia el array en memoria
    limpiarSeleccionContenedor(); // limpia localStorage
    onClose(); // 🔴 Cierra el modal
    if (onUpdateContenedores) onUpdateContenedores(); // 🔁 Actualiza el padre si es necesario
  };

  // se llama cada vez que el hijo confirma selección
  // 🔁 Se llama cada vez que el hijo confirma selección
  const recomputarResumenMostrado = () => {
    try {
      if (!resumenContenedor) return;

      const base = resumenContenedor; // valores reales (BD)
      const lista = (obtenerTodo && obtenerTodo()) || [];
      const cid = String(contenedor?.IdContenedor ?? "");

      // Solo del contenedor actual
      const items = lista.filter(
        (it) => String(it?.contenedorId ?? "") === cid,
      );

      // Nos quedamos con la ÚLTIMA versión por LE (si abriste varias veces el mismo pedido)
      const lastByLE = new Map();
      for (const it of items) {
        if (it?.idListaEmpaque == null) continue;
        lastByLE.set(it.idListaEmpaque, it);
      }

      // Calcular DELTA respecto a la BD: factor = (asociada ? 1 : 0) - (baselineAsociada ? 1 : 0)
      let deltaCbm = 0,
        deltaPeso = 0;
      const deltaTipos = {};

      for (const it of lastByLE.values()) {
        const prev = it?.baselineAsociada ? 1 : 0; // cómo estaba en BD
        const next = it?.asociada ? 1 : 0; // cómo lo quiere el usuario ahora
        const factor = next - prev; // -1, 0 o +1

        if (factor !== 0) {
          const cbm = parseDecimalSmart(
            it.CBMTotal ?? it.CBM ?? it.CubCaja ?? it.cbm ?? 0,
          );
          const peso = parseDecimalSmart(
            it.PesoBruto ?? it.PesoCaja ?? it.Peso ?? it.peso ?? 0,
          );
          const tipo = it.TipoMcia || "N";

          deltaCbm += factor * cbm;
          deltaPeso += factor * peso;
          deltaTipos[tipo] = (deltaTipos[tipo] || 0) + factor * cbm;
        }
      }

      // Fusiona REAL (BD) + DELTA (memoria)
      const mergedTipos = { ...(base.tiposMercancia || {}) };
      Object.entries(deltaTipos).forEach(([k, v]) => {
        mergedTipos[k] = (mergedTipos[k] || 0) + v;
        // opcional: evitar negativos por redondeos
        // if (mergedTipos[k] < 0) mergedTipos[k] = 0;
      });

      setResumenMostrado({
        ...base,
        cbm: parseDecimalSmart(base.cbm) + deltaCbm,
        peso: parseDecimalSmart(base.peso) + deltaPeso,
        tiposMercancia: mergedTipos,
      });

      // console.debug('Δ preview ->', { deltaCbm, deltaPeso, deltaTipos });
    } catch (e) {
      console.error("Error recomputando barra:", e);
    }
  };

  const asociarPedidos = async () => {
    const seleccionFinal = obtenerTodo();

    if (seleccionFinal.length === 0) {
      alert("⚠️ No hay productos seleccionados para asociar.");
      return;
    }

    //console.log('📦 Lista enviada al SP:', seleccionFinal);

    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/asociar-listas-empaque`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ lista: seleccionFinal }),
        },
      );

      const result = await response.json();

      if (result.status === "ok") {
        alert("Listas de empaque asociadas correctamente.");
        setSelectedPedidos([]);
        cargarResumenContenedor();

        if (onUpdateContenedores) onUpdateContenedores(); // 🔁 Recargar al guardar también

        handleClose();

        //onClose();
      } else {
        alert(`Error: ${result.message}`);
        console.error(result);
      }
    } catch (error) {
      console.error("Error al enviar al backend:", error);
      alert("Error de red o servidor.");
    }
  };

  //resumen para el dashboard

  return (
    <Dialog
      header={title}
      visible={isOpen} // 🔹 Controla si el modal está abierto
      style={{ width: "90vw" }}
      modal
      //onHide={onClose} // 🔹 Se cierra el modal cuando el usuario lo cierra
      onHide={handleClose}
      className="cssAsociarPedCtnModal"
    >
      {contenedor ? (
        <div className="contenedor-flex">
          {/* <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start', flexWrap: 'wrap' }}> */}
          <div style={{ width: "35%" }}>
            <p>
              <strong>Nro Ctn.:</strong> {contenedor.IdContenedor}
            </p>
          </div>

          {resumenContenedor && (
            <>
              <DashboardContenedor
                resumenActual={resumenContenedor}
                resumenPrevisualizado={resumenMostrado}
              />
            </>
          )}
        </div>
      ) : (
        <p>Cargando información del contenedor...</p>
      )}

      {/* Listado de Pedidos - Contenedor Flexible */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch" /* Estirar para usar todo el alto */,
          gap: "1rem",
          marginBottom: "1rem",
          flex: "1 1 auto" /* Crece y ocupa espacio restante */,
          overflow: "hidden" /* Clave para scroll interno */,
          minHeight: 0 /* Fix flexbox scroll */,
        }}
      >
        <div
          style={{
            flex: 2,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <h2>{pedidosTitulo}</h2>
          <DataTable
            value={pedidos}
            responsiveLayout="scroll"
            scrollable
            scrollHeight="flex" /* Ocupa el alto disponible del padre */
            className="tabla-pedidos-scroll"
          >
            <Column
              header={seleccionar}
              body={(rowData) => (
                <MultiStateCheckbox
                  value={
                    estadoCheckPedidos[rowData.idpedido]?.estado || "unchecked"
                  }
                  options={estadosCheckbox}
                  optionValue="value"
                  className="p-checkbox-sm"
                  readOnly
                />
              )}
            />
            <Column field="idpedido" header="ID Pedido" />
            <Column field="sMarca" header={Marca} />
            <Column field="sNombreCliente" header={cliente} />
            <Column field="sNombreEstadoPedido" header={estadoPedido} />
            <Column
              header=""
              body={(rowData) => (
                <Button
                  id={`btn-ctn-ver-listas-${rowData.idpedido}`} // ID único por fila
                  icon="pi pi-truck"
                  className="p-button-rounded p-button-text"
                  tooltip="Ver Listas de Empaque"
                  onClick={() => handleAbrirListas(rowData)}
                />
              )}
            />
          </DataTable>
        </div>

        <div style={{ flex: 1, overflowY: "auto" }}>
          {/* [EXPERT_UI]: Espaciador invisible para alinear el dashboard con la tabla (misma altura que h2) */}
          <h2 style={{ visibility: "hidden" }}>{pedidosTitulo}</h2>
          <AlertasDashboard resumen={resumenMostrado || resumenContenedor} />
        </div>
      </div>

      {/* Botón de confirmación */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Button
          id="btn-ctn-asociar-confirmar"
          label={botonAsociar}
          icon="pi pi-check"
          className="p-button-success"
          onClick={asociarPedidos}
        />
      </div>
      {/* ✅ MODAL SECUNDARIO */}
      {pedidoSeleccionado && (
        <LEAsociarPedCtnModal
          visible={modalListasVisible}
          onHide={() => setModalListasVisible(false)}
          pedido={pedidoSeleccionado}
          contenedor={contenedor} //paso el contenedor para que el otro modal lo vea
          onEstadoCheckBoxes={actualizarEstadoCheck}
          onConfirmarSeleccion={recomputarResumenMostrado}
        />
      )}
    </Dialog>
  );
};

export default AsociarPedContenedorModal;
